// ---------------- FIND YOUR PERFECT SASH ----------------
const SIZE = ["half", "half_flap", "full"];
const MAT = ["nylon", "cloth", "faux", "leather"];
const STYLE = ["classic", "colorful", "printed", "fringe", "utility", "statement"];

export const productQuestions = [
  {
    q: "What job is your Sash being hired for?",
    options: [
      { k: "A", t: "This is going to be my everyday bag. My actual life lives in here.", w: { full: 3 } },
      { k: "B", t: "I want my essentials with me without carrying my whole life.", w: { half_flap: 3 } },
      { k: "C", t: "Mostly travel, walking, concerts, errands, sightseeing or hands-free days.", w: { half: 3 } },
      { k: "D", t: "I already have a big everyday bag. I want something smaller and insanely convenient.", w: { half: 1.5, half_flap: 1.5 } },
    ],
  },
  {
    q: "Be honest. How much stuff are you carrying?",
    options: [
      { k: "A", t: "Phone, cards, keys and lip balm. Done.", w: { half: 3 } },
      { k: "B", t: "Phone, wallet, sunglasses, charger and a few essentials.", w: { half_flap: 3 } },
      { k: "C", t: "Enough to get through most normal human emergencies.", w: { full: 3 } },
      { k: "D", t: "Gum, sunscreen, meds, a charger, a snack, possibly a screwdriver? Ask me.", w: { full: 4 } },
    ],
  },
  {
    q: "How do you treat your bags?",
    options: [
      { k: "A", t: "Throw it on the floor, get it dirty, travel with it, don't worry about it.", w: { nylon: 3 } },
      { k: "B", t: "I use my things. Not precious, but not destroying them either.", w: { cloth: 1.5, faux: 1.5 } },
      { k: "C", t: "I love beautiful things and I'm willing to take care of them.", w: { leather: 3 } },
      { k: "D", t: "I want elevated and polished without the maintenance of leather.", w: { faux: 3 } },
    ],
  },
  {
    q: "Which sounds most like your personal style?",
    options: [
      { k: "A", t: "Classic, easy and understated.", w: { leather: 1.5, faux: 1.5, classic: 2 } },
      { k: "B", t: "Color is basically a neutral as far as I'm concerned.", w: { colorful: 3 } },
      { k: "C", t: "Prints make everything better.", w: { printed: 3, cloth: 2 } },
      { k: "D", t: "I want something people are going to ask me about.", w: { fringe: 2, statement: 2, printed: 1 } },
    ],
  },
  {
    q: "Someone compliments your Sash. What response feels most like you?",
    options: [
      { k: "A", t: "\u201CThank you! I've had it forever.\u201D", w: { classic: 2, leather: 2 } },
      { k: "B", t: "\u201CWAIT. Let me show you all the pockets.\u201D", w: { full: 2, half_flap: 1 } },
      { k: "C", t: "\u201CI KNOW. LOOK AT THIS FABRIC.\u201D", w: { printed: 2, cloth: 1, colorful: 1 } },
      { k: "D", t: "\u201COh, you've never heard of Sash? Okay, sit down.\u201D", w: { statement: 3, fringe: 1, colorful: 1 } },
    ],
  },
  {
    q: "Pick your dream Sash vibe.",
    options: [
      { k: "A", t: "Black / Cognac / Rich Neutrals", w: { classic: 3, leather: 1 } },
      { k: "B", t: "Teal / Purple / Berry / Jewel Tones", w: { colorful: 3 } },
      { k: "C", t: "Florals / Ikat / Paisley / Graphic Prints", w: { printed: 3 } },
      { k: "D", t: "Denim / Utility / Casual Texture", w: { utility: 3, nylon: 1 } },
      { k: "E", t: "Fringe / Studs / Embroidery / Decorative Details", w: { fringe: 3, statement: 1 } },
    ],
  },
];

export function scoreProduct(answers) {
  const s = {};
  answers.forEach((o) => { for (const k in o.w) s[k] = (s[k] || 0) + o.w[k]; });
  const pick = (keys) => keys.reduce((a, b) => (s[b] || 0) > (s[a] || 0) ? b : a, keys[0]);
  return { size: pick(SIZE), material: pick(MAT), style: pick(STYLE), scores: s };
}

export const sizeLabel = { half: "Half Sash", half_flap: "Half Sash with Flap", full: "Full Sash" };
export const matLabel = { nylon: "Nylon", cloth: "Cloth", faux: "Faux Leather", leather: "Leather" };
export const styleLabel = { classic: "Classic / Neutral", colorful: "Colorful", printed: "Printed", fringe: "Fringe / Embellished", utility: "Utility / Casual", statement: "Statement Piece" };
const styleFlair = { classic: "Keeping It Classic", colorful: "A Pop of Color", printed: "Print Lover", fringe: "A Little Drama", utility: "Low-Key Utility", statement: "Main Character Energy" };
const sizeReason = {
  half: "You do not need to carry your entire household around with you. Half Sash it is.",
  half_flap: "You want your essentials close without lugging your whole life. The Half Sash with Flap is exactly your lane.",
  full: "You are absolutely a Full Sash person. You carry more than the bare minimum and you want all of it with you.",
};
const matReason = {
  nylon: "You want cute, durable and low-maintenance. Nylon is basically begging to come home with you.",
  cloth: "You use your things without being precious about them, so Cloth gives you personality and easy wear.",
  faux: "You want elevated and polished without the fuss of leather. Faux Leather, hello.",
  leather: "You love beautiful things and you'll take care of them. Leather it is \u2014 it only gets better with age.",
};
const styleReason = {
  classic: "Boring? No. Timeless? Absolutely. You want something that quietly goes with everything.",
  colorful: "Color is a neutral as far as you're concerned, and honestly, respect.",
  printed: "Prints make everything better and you already know it.",
  fringe: "You want a bag people ask you about. Fringe, studs, the works.",
  utility: "You want function-first, throw-it-anywhere energy.",
  statement: "You want the bag that makes people stop mid-sentence and go WAIT.",
};

export function productResult(r) {
  return {
    title: `${sizeLabel[r.size]} + ${matLabel[r.material]} + ${styleFlair[r.style]}`,
    blurb: `${sizeReason[r.size]} ${matReason[r.material]} ${styleReason[r.style]}`,
    watchFor: [sizeLabel[r.size], matLabel[r.material], styleLabel[r.style]],
  };
}

// ---------------- WHAT KIND OF SASH SISTER ----------------
const ARCH = ["mayor", "lurker", "shopper", "collector", "evangelist", "unicorn"];

export const sisterQuestions = [
  {
    q: "A Sash Live is happening tonight. You are\u2026",
    options: [
      { k: "A", t: "Already there five minutes early.", w: { mayor: 3 } },
      { k: "B", t: "Watching, but probably not commenting.", w: { lurker: 3 } },
      { k: "C", t: "I'll watch the replay if something good happened.", w: { shopper: 2, lurker: 1 } },
      { k: "D", t: "There was a Live?", w: { unicorn: 2, lurker: 1 } },
    ],
  },
  {
    q: "Someone posts, \u201CWhich Sash should I buy?\u201D in the community. What do you do?",
    options: [
      { k: "A", t: "I have questions. What do you carry? What colors do you wear? Do you have a Half yet?", w: { evangelist: 2, mayor: 1 } },
      { k: "B", t: "I read everyone else's answers because this discussion is absolutely relevant to me.", w: { lurker: 3 } },
      { k: "C", t: "I might tell them which one I own.", w: { collector: 1, shopper: 1 } },
      { k: "D", t: "I am not in the group and frankly had no idea these conversations were happening.", w: { unicorn: 2, shopper: 1 } },
    ],
  },
  {
    q: "A new Sash drops in your favorite color. What happens next?",
    options: [
      { k: "A", t: "Purchased.", w: { shopper: 3, collector: 1 } },
      { k: "B", t: "I'm staring at it, thinking about it, and possibly adding it to my cart three separate times.", w: { lurker: 2, collector: 1 } },
      { k: "C", t: "I'll wait and see what else launches.", w: { mayor: 2 } },
      { k: "D", t: "I already own a bag.", w: { unicorn: 3 } },
    ],
  },
  {
    q: "How many Sashes is too many?",
    options: [
      { k: "A", t: "I don't understand the question.", w: { collector: 3 } },
      { k: "B", t: "Depends. How different are the colors/materials/styles?", w: { collector: 2 } },
      { k: "C", t: "More than three feels excessive.", w: { shopper: 1, unicorn: 1 } },
      { k: "D", t: "One. One functional bag is a completely normal number of bags.", w: { unicorn: 3 } },
    ],
  },
  {
    q: "Someone compliments your Sash in public. What happens?",
    options: [
      { k: "A", t: "They are getting the full Sash story. I hope they didn't have somewhere to be.", w: { evangelist: 3 } },
      { k: "B", t: "I tell them what it is, why I love it and where they can find one.", w: { evangelist: 1, mayor: 1 } },
      { k: "C", t: "\u201CThanks!\u201D", w: { shopper: 1, lurker: 1 } },
      { k: "D", t: "I forgot I was wearing it.", w: { unicorn: 1, lurker: 1 } },
    ],
  },
  {
    q: "An email arrives with the subject line \u201CNEW SASH DROP.\u201D You\u2026",
    options: [
      { k: "A", t: "Have already opened it before the notification finishes loading.", w: { mayor: 3 } },
      { k: "B", t: "Open it eventually because I genuinely like seeing what's new.", w: { lurker: 1, mayor: 1 } },
      { k: "C", t: "Open it if I'm currently in the market for something.", w: { shopper: 2 } },
      { k: "D", t: "Delete it unless I actually need a new bag.", w: { unicorn: 2 } },
    ],
  },
  {
    q: "Be honest: what happens when you find a Sash you LOVE?",
    options: [
      { k: "A", t: "I immediately start thinking about whether I also need it in another color.", w: { collector: 3 } },
      { k: "B", t: "I obsess over it for several days before making a responsible-ish decision.", w: { lurker: 2 } },
      { k: "C", t: "I buy it if I need it.", w: { shopper: 2 } },
      { k: "D", t: "Once I own one functional version of something, the problem has been solved.", w: { unicorn: 3 } },
    ],
  },
];

export function scoreSister(answers) {
  const s = {};
  answers.forEach((o) => { for (const k in o.w) s[k] = (s[k] || 0) + o.w[k]; });
  const pick = ARCH.reduce((a, b) => (s[b] || 0) > (s[a] || 0) ? b : a, ARCH[0]);
  return { result: pick, scores: s };
}

export const sisterResults = {
  mayor: {
    title: "The Mayor of Sashville",
    blurb: "You know what's launching before half the staff does. You're in the community, you read the emails, you show up for Lives, and you've probably answered another customer's question even though nobody technically asked you. Sash isn't just a bag company to you. You live here.",
  },
  lurker: {
    title: "The Sash Lurker",
    blurb: "You're here. You're watching. You know exactly what's happening. But you are absolutely not commenting \u201Cfollowing\u201D under a 146-comment Facebook thread. You enjoy the Sash universe from a safe, comfortable distance and emerge only when something really good drops.",
  },
  shopper: {
    title: "The Drop-Everything Shopper",
    blurb: "You don't need the community. You don't need the Lives. You don't need a 47-email courtship sequence. Show you the bag. If you like the bag, you buy the bag. Thank you for your efficiency.",
  },
  collector: {
    title: "The Collector",
    blurb: "You originally came here because you \u201Cneeded a bag.\u201D We both know how that went. At this point your Sashes may require their own organizational infrastructure. And yes, the different colors are absolutely different enough.",
  },
  evangelist: {
    title: "The Sash Evangelist",
    blurb: "Someone asks about your bag in Target and suddenly you're twelve minutes into explaining the design, the pockets, why it's hands-free and why they need to look up Sash. You didn't choose the Sash evangelist life. The Sash evangelist life chose you.",
  },
  unicorn: {
    title: "The One-And-Done Unicorn",
    blurb: "You bought one Sash. You love it. It still works. You see absolutely no logical reason why this means you should own fourteen more. The rest of the Sash community finds you fascinating.",
  },
};

// ---------------- DESIGN LAB ----------------
export const dlPalette = [
  { name: "Teal", hex: "#1a8a7e" },
  { name: "Purple", hex: "#6b4a9e" },
  { name: "Berry", hex: "#9e2b4e" },
  { name: "Cognac", hex: "#a25a2a" },
  { name: "Black", hex: "#23201d" },
  { name: "Red", hex: "#b0202f" },
  { name: "Mustard", hex: "#d29a2a" },
  { name: "Sky", hex: "#3f86c7" },
  { name: "Olive", hex: "#6b7233" },
  { name: "Blush", hex: "#d98a8f" },
];
